import { Mic, Square, Loader2 } from "lucide-react";

export const ArcReactor = ({ state, onClick }) => {
  const active = state === "listening";
  const busy = state === "processing" || state === "speaking";
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="arc-reactor-voice-button"
      aria-label="Talk to JARVIS"
      className="relative w-44 h-44 rounded-full flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 group"
    >
      <span className={`absolute inset-0 rounded-full border border-dashed border-cyan-400/40 ring-spin ${busy ? "ring-fast" : ""}`} />
      <span className={`absolute inset-3 rounded-full border-2 border-cyan-500/30 border-t-cyan-300 ring-spin-rev ${busy || active ? "ring-fast" : ""}`} />
      <span className="absolute inset-7 rounded-full border border-cyan-400/50" />
      <span
        className={`relative w-20 h-20 rounded-full bg-cyan-950 border-2 border-cyan-300 flex items-center justify-center transition-shadow duration-300 shadow-[0_0_20px_rgba(255,154,77,0.6)] group-hover:shadow-[0_0_44px_rgba(255,154,77,0.9)] ${active ? "reactor-active bg-cyan-800" : ""}`}
      >
        {state === "processing" ? (
          <Loader2 className="text-cyan-100 animate-spin" size={28} />
        ) : active ? (
          <Square className="text-cyan-50" size={24} fill="currentColor" />
        ) : (
          <Mic className="text-cyan-100" size={28} />
        )}
      </span>
    </button>
  );
};
